import React, { FunctionComponent } from 'react'

import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import { usePaymentSchedule } from '../../paymentScheduleContext'
import { useProduct } from '../../productContext'
import { PaymentDisabled } from './PaymentDisabled'
import { PaymentManager } from './PaymentManager'
import { PaymentPage } from './PaymentPage'

export const PaymentRoute: FunctionComponent = () => {
  const {
    product: { payment },
  } = useProduct()

  const { disableBind } = useConfig(getFeatureToggles)
  const { paymentScheduleType } = usePaymentSchedule()

  const paymentScheduleConfig = payment?.schedules?.find(
    (it) => it.type === paymentScheduleType,
  )

  return paymentScheduleConfig && !disableBind ? (
    <PaymentManager>
      <PaymentPage config={paymentScheduleConfig} />
    </PaymentManager>
  ) : (
    <PaymentDisabled />
  )
}
